import styles from './../../index.module.scss'
import iconLineDouble from '@/assets/image/solution/custodial/line_double.png';
import iconLinePurple2 from '@/assets/image/solution/custodial/line_purple2.png';
import iconLineGray from '@/assets/image/solution/custodial/line_gray.png';
import iconLineYellow from '@/assets/image/solution/custodial/line_yellow.png';
import flowImg3 from '@/assets/image/solution/custodial/flow_img3.png';
import iconLineYellowMobile from '@/assets/image/solution/custodial/line_yellow_mobile.png';
import iconLineDoubleMobile from '@/assets/image/solution/custodial/line_double_mobile.png';
import iconLinePurple2Mobile from '@/assets/image/solution/custodial/line_purple2_mobile.png';
import iconLineGrayMobile from '@/assets/image/solution/custodial/line_gray_mobile.png';
import flowImg3Mobile from '@/assets/image/solution/custodial/flow_img3_mobile.png';
import { useMediaQuery } from 'react-responsive';

const Card4 = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={`${styles.card2} w-1340`}>
      {
        isMobile?(
          <>
            <div className={`${styles.cardHead}`} style={{ marginBottom: '0px' }}>
              <div className={`${styles.headTitle}`}>
                Vishwa Trustless Orchestration in Action: Optimal Strategy Found
              </div>
              <div className={`${styles.headExtra} flex flex-wrap`}>
                <div className={`${styles.headExtra} ${styles.headExtra2} flex align-items`}>
                  <img src={iconLineGrayMobile} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>The Manual Way</div>
                </div>
                <div className={`${styles.headExtra} ${styles.headExtra2} flex align-items`}>
                  <img src={iconLinePurple2Mobile} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>Optimal Liquidity</div>
                </div>
                <div className={`${styles.headExtra} ${styles.headExtra2} flex align-items`}>
                  <img src={iconLineDoubleMobile} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>Vishwa ONLY</div>
                </div>
                <div className={`${styles.headExtra} ${styles.headExtra2} flex align-items`}>
                  <img src={iconLineYellowMobile} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>Optimal Yields</div>
                </div>
              </div>
            </div>
            <div className={`${styles.cardSubHead}`}>
              <div className={`${styles.subHeadTitle}`}>
                Purpose
              </div>
              <div className={`${styles.subHeadSubTitle}`} style={{ marginBottom: '30px' }}>
                From my portfolio: <br />
                1. Find 10,000 USDC liquidity; <br />
                2. Find the best yields for the remainder
              </div>
            </div>
            <div className={`${styles.cardSubHead}`} style={{ marginBottom: '36px'}}>
              <div className={`${styles.subHeadTitle}`}>
                Optimal Strategy Found
              </div>
              <div className={`${styles.subHeadSubTitle}`}>
                Action: Utilized BTC, SUI, & Tokenized NVDA as collateral.<br />
                Outcome: 10,000 USDC liquidity generated<br />
                Cost: 6% APY in Base & 7.5% APY in Morpho ETH<br />
              </div>
            </div>
            <div className={`${styles.cardContent}`}>
              <img src={flowImg3Mobile} data-src={flowImg3Mobile} loading="lazy" />
            </div>
          </>
        ) : (
          <>
            <div className={`${styles.cardHead} flex flex-just`} style={{ marginBottom: '0px' }}>
              <div className={`${styles.headTitle}`}>
                Vishwa Trustless Orchestration in Action: <br/>
                Optimal Strategy Found
              </div>
              <div className={`${styles.headExtra}`}>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLineGray} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>The Manual Way</div>
                </div>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLinePurple2} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>Optimal Liquidity</div>
                </div>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLineDouble} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>Vishwa ONLY</div>
                </div>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLineYellow} className={styles.line} />
                  <div className={`${styles.headExtraText86}`}>Optimal Yields</div>
                </div>
              </div>
            </div>
            <div className={`${styles.cardSubHead}`}>
              <div className={`${styles.subHeadTitle}`}>
                Purpose
              </div>
              <div className={`${styles.subHeadSubTitle}`} style={{ marginBottom: '48px' }}>
                From my portfolio:  1. Find 10,000 USDC liquidity;   2. Find the best yields for the remainder
              </div>
            </div>
            <div className={`${styles.cardSubHead}`} style={{ marginBottom: '120px', marginTop: '48px' }}>
              <div className={`${styles.subHeadTitle}`}>
                Optimal Strategy Found
              </div>
              <div className={`${styles.subHeadSubTitle}`}>
                Action: Utilized BTC, SUI, & Tokenized NVDA as collateral.<br />
                Outcome: 10,000 USDC liquidity generated<br />
                Cost: 6% APY in Base & 7.5% APY in Morpho ETH<br />
              </div>
            </div>
            <div className={`${styles.cardContent}`}>
              <img src={flowImg3} data-src={flowImg3} loading="lazy" />
            </div>
          </>
        )
      }

    </div>
  )
}

export default Card4